import React from "react";
import { Link } from "react-router-dom";
import usePhotoOffer from "./usePhotoOffer";

// The "print photos" card under the template card, with the same markup so it takes the
// same look on each page; .is-photo gives it warm colours (App.css). Hidden until the
// admin has set a photo price, which is what puts photos on sale. ID photos, on sale by
// their own price, are a tab of the photo page and a tag here.

const money = (value) => Number(value).toLocaleString() + "₮";

const PhotoCta = () => {
  const offer = usePhotoOffer();

  if (!offer || !offer.price) return null;
  const { price } = offer;
  const idPhotos = Boolean(offer.idPrice);

  return (
    <Link to="/photo" className="template-cta is-photo">
      <span className="template-cta-icon">
        <i className="fas fa-image"></i>
      </span>
      <span className="template-cta-body">
        <span className="template-cta-title">
          <span className="template-cta-badge">Шинэ</span>
          10×15 зураг хэвлэх
        </span>
        <span className="template-cta-text">
          Утаснаасаа зургаа сонгоод «Зураг» карттай киоскоос фото цаасан дээр хэвлээрэй
        </span>
        <span className="template-cta-tags">
          <span>10×15 см</span>
          <span>Өнгөт</span>
          <span>{money(price)} / зураг</span>
          {idPhotos && <span>Цээж зураг</span>}
        </span>
      </span>
      <span className="template-cta-go">
        Зураг сонгох
        <span className="template-cta-arrow">
          <i className="fas fa-arrow-right"></i>
        </span>
      </span>
    </Link>
  );
};

export default PhotoCta;
